// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3yQHT","legacyBtn":"MutateMid_legacyBtn__1HsPP"};